import { useQuery } from '@tanstack/react-query';

import {
  getEnterpriseById,
  getEnterpriseCreditsConsumption,
  getEnterpriseCreditsTopUp,
  getEnterprises,
  getEnterprisesSuggestions,
} from '../services/enterpriseService';
import ISearchCriteria from '@models/dto/searchCriteria.dto';
import IPaginatedParams from '@models/paginated-params';

export const useGetEnterprises = (
  paginatedParams: IPaginatedParams,
  searchCriteria: ISearchCriteria,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: ['enterprises', paginatedParams, searchCriteria],
    queryFn: () => getEnterprises(paginatedParams, searchCriteria),
    enabled,
  });
};

export const useGetEnterpriseById = (
  id: string | undefined,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: ['enterprise', id],
    queryFn: () => getEnterpriseById(id),
    enabled: !!id && enabled,
    cacheTime: 0,
    refetchOnMount: 'always',
  });
};

export const useGetEnterprisesSuggestions = (
  limit: number,
  page: number,
  query: string,
) => {
  const enabled = query.length > 2;
  const params: IPaginatedParams = { limit, page, query };
  return useQuery({
    queryKey: ['enterprises_suggesstions', limit, page, query],
    queryFn: () => getEnterprisesSuggestions(params),
    enabled,
  });
};

export const useGetEnterpriseCreditsConsumption = (
  id: string | undefined,
  paginatedParams: IPaginatedParams,
) => {
  return useQuery({
    queryKey: ['enterprise_credits_consumption', id, paginatedParams],
    queryFn: () => getEnterpriseCreditsConsumption(id, paginatedParams),
  });
};

export const useGetEnterpriseCreditsTopUp = (
  id: string | undefined,
  paginatedParams: IPaginatedParams,
) => {
  return useQuery({
    queryKey: ['enterprise_credits_topup', id, paginatedParams],
    queryFn: () => getEnterpriseCreditsTopUp(id, paginatedParams),
  });
};
